<template>
    <div class="datastatistics">
        <el-row style="display: flex; align-items: center; margin-bottom: 10px;">
            <div style="margin-left: 20px;">到课人数（{{ total }}）</div>
            <el-input v-model="query.user_id" placeholder="请输入用户ID" size="mini" maxlength="10" @input="handleInput"></el-input>
            <el-input v-model="query.nickname" placeholder="请输入用户昵称" size="mini" maxlength="10"></el-input>
            <el-button size="mini" type="primary" @click="getList">搜索</el-button>
            <el-button size="mini" type="primary" @click="dialogVisible = true">导出</el-button>
        </el-row>
        <el-row>
            <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
                <el-table-column prop="user_id" label="用户ID" align="center" min-width="4%">
                    <template slot-scope="scope">
                        <div style="color: #409eff; cursor: pointer;" @click="toinfo(scope.row.user_id)">
                            {{ scope.row.user_id }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="用户昵称" align="center" min-width="4%">
                </el-table-column>
                <el-table-column prop="total_duration" label="学习时长" align="center" min-width="3%">
                </el-table-column>
                <el-table-column prop="updated_at" label="最近观看时间" align="center" min-width="12%"></el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page" @size-change="handleSizeChange" :page-size="query.limit"
                               :page-sizes="[10,20, 30, 40, 50]" layout="total, sizes,prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog title="导出" :visible.sync="dialogVisible" width="20%" :before-close="handleClose">
            <div style="font-weight: 600;">是否确认导出</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="deriveHandel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getStudyUserList } from "@/api/datastatistics";
export default {
    name: "",
    data() {
        return {
            query: {
                period_id: "",
                user_id: "",
                nickname: "",
                limit: 10,
                page: 1,
            },
            loading: true,
            total: null,
            tableData: [],
            dialogVisible:false,
        };
    },
    created() {
        this.query.period_id = this.$route.query.id;
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            getStudyUserList(this.query).then((res) => {
                if (res.code == 1) {
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                    this.loading = false
                }
            });
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        handleInput(value) {
            const filteredValue = value.replace(/\D/g, "");
            // 更新数据
            this.query.user_id = filteredValue;
        },
        deriveHandel() {
            // 导出
            //   // location.href = `https://dev.backend.zhangdefenspace.com/backend/psy/settlement/export-psy-list?status=${this.query.status}`
            // https://backend.zhangdefenspace.com/backend})
            //   let url = 'https://backend.zhangdefenspace.com/backend/psy/settlement/export-psy-list?';
            let url = "https://backend.zhangdefenspace.com/backend/psy/settlement/export-psy-list?";
            if (this.query.period_id != "") {
                url += `period_id=${this.query.period_id}&`;
            }
            if (this.query.nickname != "") {
                url += `nickname=${this.query.nickname}&`;
            }
            if (this.query.user_id != "") {
                url += `user_id=${this.query.user_id}&`;
            }

            // 移除最后一个字符（可能是 '&'）
            // url = url.slice(0, -1);

            // 跳转
            console.log(url);
            location.href = url;
            console.log(url, "url");
            this.dialogVisible = false
        },
        toinfo(id) {
      this.$router.push({
        path: "/user/info",
        query: {
          id: id,
        }
      });
    },
    },
};
</script>

<style>
.datastatistics .el-input {
    width: 180px;
    margin-right: 30px;
}
.datastatistics .block .el-input {
    width: 80px;
}
.datastatistics .el-table td,
.el-table th {
    padding: 8px 0;
}
</style>
